(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !window.DesignMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.header-section');
      this.announcementBar = document.querySelector('.announcement-bar-section'); // Optional
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.setHeaderHeight();
      window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      if (this.announcementBar) {
        document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (this.header.preventHide) {
          return;
        }

        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["health-journey-about-us"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const healthContainer = document.querySelector('.health-journey-container');
    const healthTabs = document.querySelectorAll('.health-journey-tab');
    const contents = document.querySelectorAll('.health-journey-content');

    healthContainer.style.background = contents[0].getAttribute('data-bg');

    healthTabs.forEach((tab, index) => {
      tab.addEventListener('click', function () {
        healthTabs.forEach((t) => t.classList.remove('active'));
        contents.forEach((c) => c.classList.remove('active'));

        tab.classList.add('active');
        contents[index].classList.add('active');

        const activeContent = contents[index];
        const bgColor = activeContent.getAttribute('data-bg');
        healthContainer.style.background = bgColor;
      });
    });

    // Desktop tabs functionality
    const tabs = document.querySelectorAll('.health-journey-tab');
    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        // Remove active class from all tabs and content
        document.querySelectorAll('.health-journey-tab').forEach((t) => t.classList.remove('active'));
        document.querySelectorAll('.health-journey-content').forEach((c) => c.classList.remove('active'));

        // Add active class to clicked tab
        this.classList.add('active');

        // Show corresponding content
        const tabId = this.getAttribute('data-tab-id');
        document.getElementById('tab-content-' + tabId).classList.add('active');
      });
    });

    // Mobile accordion functionality
    const accordionHeader = document.querySelector('.accordion-header');
    const accordionContent = document.querySelector('.accordion-content');
    const accordionArrow = document.querySelector('.accordion-arrow');
    const activeTabText = document.querySelector('.active-tab-text');

    if (accordionHeader) {
      accordionHeader.addEventListener('click', function () {
        accordionContent.classList.toggle('open');
        accordionArrow.classList.toggle('rotate');
      });
    }

    // Mobile accordion items functionality
    const accordionItems = document.querySelectorAll('.accordion-item');
    accordionItems.forEach((item) => {
      item.addEventListener('click', function () {
        // Remove active class from all items and content
        document.querySelectorAll('.accordion-item').forEach((i) => i.classList.remove('active'));
        document.querySelectorAll('.health-journey-content').forEach((c) => c.classList.remove('active'));

        // Add active class to clicked item
        this.classList.add('active');

        // Show corresponding content
        const tabId = this.getAttribute('data-tab-id');
        const activeContentMobile = document.getElementById('tab-content-' + tabId);
        activeContentMobile.classList.add('active');

        healthContainer.style.background = activeContentMobile.getAttribute('data-bg');

        // Update the active tab text in the header
        if (activeTabText) {
          activeTabText.textContent = this.textContent.trim();
        }

        // Close the accordion
        accordionContent.classList.remove('open');
        accordionArrow.classList.remove('rotate');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
